import _extends from "@babel/runtime/helpers/extends";
import { Breakpoint } from '@wix/form-fields';
import classNames from 'classnames';
import React, { forwardRef, useState, useMemo } from 'react';
import { TRANSLATIONS_NAMESPACE } from '../../constants/translations';
import { FormRoot } from '../form';
import { DisabledFormOverlay } from './disabled-form-overlay';
import { FormViewerProvider } from './form-viewer-provider';
import styles from './form-viewer-static.module.scss';
export const FormViewerStatic = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  var _formWithValidSteps$p, _formWithValidSteps$p2;
  let {
    form,
    i18n,
    isMobile,
    isRTL,
    config = null,
    readOnly = false,
    externalData,
    bi,
    biFormFillSessionId,
    translations,
    localeDataset,
    forcedState,
    httpClient,
    panorama,
    experiments,
    currency,
    fields,
    WixRicosViewer,
    breakpoint = Breakpoint.LARGE,
    allowFormDisable = true,
    fieldInitialData,
    validationMode,
    enableAnimations,
    ...rest
  } = _ref;
  const {
    language = 'en',
    regionalFormat = 'en',
    userData
  } = config || {};
  useState(() => {
    translations && i18n.addResources(language, TRANSLATIONS_NAMESPACE, translations);
    localeDataset && i18n.addResources(language, TRANSLATIONS_NAMESPACE, localeDataset);
  });
  const formWithValidSteps = useMemo(() => {
    var _form$steps;
    return {
      ...form,
      steps: (form == null || (_form$steps = form.steps) == null ? void 0 : _form$steps.filter(step => {
        var _step$layout;
        return (_step$layout = step.layout) == null || (_step$layout = _step$layout.large) == null || (_step$layout = _step$layout.items) == null ? void 0 : _step$layout.length;
      })) || []
    };
  }, [form]);
  if (!form) {
    return null;
  }
  const isDisabled = allowFormDisable && ((_formWithValidSteps$p = formWithValidSteps.properties) == null ? void 0 : _formWithValidSteps$p.disabled);
  return /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(FormViewerProvider, {
    httpClient: httpClient,
    i18n: i18n,
    bi: bi,
    panorama: panorama,
    biFormFillSessionId: biFormFillSessionId,
    form: formWithValidSteps,
    language: language,
    regionalFormat: regionalFormat,
    isRTL: isRTL,
    isMobile: isMobile,
    isEditor: config == null ? void 0 : config.isEditor,
    isComposer: config == null ? void 0 : config.isComposer,
    externalData: externalData,
    forcedState: forcedState,
    instance: config == null ? void 0 : config.instance,
    experiments: experiments,
    translationNamespace: TRANSLATIONS_NAMESPACE,
    currency: currency,
    userData: userData,
    WixRicosViewer: WixRicosViewer,
    addressTemplates: config == null ? void 0 : config.addressTemplates,
    atlasBaseUrl: config == null ? void 0 : config.atlasBaseUrl,
    fieldInitialData: fieldInitialData,
    compId: config == null ? void 0 : config.compId,
    enableAnimations: enableAnimations,
    baseUrl: config == null ? void 0 : config.baseUrl
  }, /*#__PURE__*/React.createElement("form", {
    "aria-label": ((_formWithValidSteps$p2 = formWithValidSteps.properties) == null ? void 0 : _formWithValidSteps$p2.name) ?? '',
    id: `form-${formWithValidSteps.id}`,
    "data-hook": `form-${formWithValidSteps.id}`,
    className: classNames({
      [styles.readOnly]: readOnly,
      [styles.disabled]: isDisabled && !(config != null && config.isEditor)
    }),
    onSubmit: e => e.preventDefault()
  }, isDisabled && /*#__PURE__*/React.createElement(DisabledFormOverlay, {
    content: formWithValidSteps.disabledFormMessage,
    isEditor: config == null ? void 0 : config.isEditor
  }), /*#__PURE__*/React.createElement("fieldset", {
    className: styles.fieldsetReset,
    disabled: readOnly || isDisabled
  }, /*#__PURE__*/React.createElement(FormRoot, _extends({
    form: formWithValidSteps,
    fields: fields,
    forwardedRef: forwardedRef,
    config: config,
    breakpoint: breakpoint,
    validationMode: validationMode
  }, rest))))));
});
//# sourceMappingURL=form-viewer-static.js.map